var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7223 7.66675C13.8939 7.66675 13.2223 8.33832 13.2223 9.16675V15.3334H7.05566C6.22724 15.3334 5.55566 16.005 5.55566 16.8334V21.5001C5.55566 22.3285 6.22724 23.0001 7.05566 23.0001H13.2223V52.1667C13.2223 52.9952 13.8939 53.6667 14.7223 53.6667H19.389C20.2174 53.6667 20.889 52.9952 20.889 52.1667V23.0001H55.1668C55.9952 23.0001 56.6668 22.3285 56.6668 21.5001V16.8334C56.6668 16.005 55.9952 15.3334 55.1668 15.3334H20.889V9.16675C20.889 8.33832 20.2174 7.66675 19.389 7.66675H14.7223Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1667 28.1111H26V47.0555C26 47.884 26.6716 48.5555 27.5 48.5555H50.1667C53.7565 48.5555 56.6667 45.6454 56.6667 42.0555V29.6111C56.6667 28.7827 55.9951 28.1111 55.1667 28.1111ZM50 30.6666C49.4477 30.6666 49 31.1144 49 31.6666V42.4444C49 42.9967 49.4477 43.4444 50 43.4444H53.1111C53.6634 43.4444 54.1111 42.9967 54.1111 42.4444V31.6666C54.1111 31.1144 53.6634 30.6666 53.1111 30.6666H50Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.2e968fca567bf854a1bc829d120e52ca.svg";
export { ForwardRef as ReactComponent };